import AuthContext from "../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext } from "react";

import logo from "../content/img/logo-header.png";
import homeImg from "../content/img/home.svg";
import favImg from "../content/img/favorites.svg";
import recentImg from "../content/img/recents.svg";
import logoutImg from "../content/img/exit.png";
import adminSettingImg from "../content/img/admin_settings.svg";

const UserSideMenu = () => {
    let navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const location = useLocation();
    const loginResult = location.state?.loginResult;
    var czar = loginResult.user.isCzar;

    function show(page) {
        console.log('show fired');
        console.log(page);
        var fav = document.getElementById('favorites');
        var recent = document.getElementById('updated');
        
  
        // because react load will error on start
        if(fav !== null && fav !== undefined && recent !== null && recent !== undefined){
            if(page === null || page === undefined){
                document.getElementById('dashboards').style.display = 'inline';
                fav.style.display = 'inline';
                recent.style.display = 'inline';
            }else if (page === 'all') {
                document.getElementById('dashboards').style.display = 'inline';
        
                if (fav !== null) {
                    fav.style.display = 'none';
                }
        
                if (recent !== null) {
                    recent.style.display = 'none';
                }
            } else if ((page === 'fav') && (fav !== null)) {
                document.getElementById('dashboards').style.display = 'none';
                fav.style.display = 'inline';
                if (recent !== null) {
                    recent.style.display = 'none';
                }
            } else if ((page === 'recent') && (recent !== null)) {
                document.getElementById('dashboards').style.display = 'none';
                if (fav !== null) {
                    fav.style.display = 'none';
                }
                recent.style.display = 'inline';
            }
        }
    };
    
    function showCzar(){
        if (!czar) {
            return(
                <>
                <span className="left-side-button" onClick={() => showUserSettings()} >
                    <img className="button-img"  name="settings" alt="user settings" src={adminSettingImg}  />
                    <label className="nav-label">Settings</label>
                </span>
                <hr id="menuHr" width="90%" />
                </>
            );
        } else {
            return null;
        }
    }
    
    function showUserSettings() {
        console.log("Show User Settings");
        navigate("/settings", {state: {id:4, name:"UserSettings", loginResult: loginResult}});
    }

    function userLogout(){
        console.log("User clicked Logout");
        logout();
        navigate("/", {state: {id:3, name:"SessionTimeOut", loginResult: null}});
    }

    const czarSettings = showCzar();

return(
    <>
        <div id="vertical-bar" name="top-bar" hidden>
            <img id="logo" name="logo" src={logo} alt="Community Care Behavioral Health Organization" onClick={() => show()} />

            <span id="left-side-vertical-app-buttons">
                <span className="left-side-button" onClick={ () => show('all')} >
                    <img id="all-reports" className="button-img" src={homeImg} />
                    <label className="nav-label">All Reports</label>
                </span>
                <span className="left-side-button" onClick={() => show('fav')} >
                    <img id="favorite-reports" className="button-img" src={favImg} />
                    <label className="nav-label">Favorites</label>
                </span>
                <span className="left-side-button" onClick={() => show('recent')} >
                    <img id="recent-reports" className="button-img" src={recentImg} />
                    <label className="nav-label">Recently Updated</label>
                </span>
                <hr id="menuHr" width="90%" />

                {czarSettings}

                <span className="left-side-button" onClick={() => userLogout()} >
                    <img id="user-logout" className="button-img-exit" src={logoutImg} />
                    <label className="nav-label">Log Out</label>
                </span>
            </span>
        </div>
    </>
    );

};

export default UserSideMenu;